<template lang="html">
  <div 
    class="card-interview"
    :style="{ 'background-image': 'url(' + imageURL + ')' }" 
  >

    <h2>{{ title }}</h2>
    <!-- <p class="description-entrevista">{{ description }}</p> -->
    <i class="bi bi-youtube play"></i>  
  </div>
</template>
<script>
// ceedceed-nuevo/src/components/General/Button.vue
// import Button from '../General/Button.vue'

export default {
  components: {
    // Button,
  },
  props: {
    videoEmbedURL: String,
    imageURL: String,
    title: String,
    description: String,
    buttonText: String
  },
};
</script>
<style lang="css">
.card-interview {
  background: #ffffff;
  display: flex;
  flex-direction: row;
  height: 320px;
  position: relative;
}

h2 {
  font-family: Work Sans;
  font-size: 35px;
  font-weight: 600;
  line-height: 52px;
  letter-spacing: 0em;
  text-align: left;

  color: #33647e;
  position: absolute;
  left: 30px;
  top: 30px;
}
.description-entrevista {
  color: #696f72;
  position: absolute;
  left: 30px;
  top:60px
}

.card-interview {
  width: 100%;
  background-size: cover;
}
.play {
  position: absolute;
  left: 42%;
  top: 30%;
  font-size: 100px;
  color: white;
  cursor: pointer;
}
</style>
